import { render } from "./SpeakingHome.vue?vue&type=template&id=1c22aaa1&scoped=true&lang=true"
const script = {}

import "./SpeakingHome.vue?vue&type=style&index=0&id=1c22aaa1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c22aaa1"]])

export default __exports__